import { Component, OnInit } from '@angular/core';
import { TableMode } from 'src/app/components/grid/grid.component';
import { FieldDataType } from 'src/app/components/grid/FieldDataType';
import { QueryOperand } from 'src/app/components/grid/QueryOperand';
import { ITableData } from 'src/app/components/grid/ITableData';
import { IColumn } from 'src/app/components/grid/IColumn';
import { GridUtil } from 'src/app/components/grid/GridUtil';
import { EventService } from 'src/app/services/event-services/error-event.service';
import { ExamScheduleService } from 'src/app/services/exam-schedule-service';
import { ExamService } from 'src/app/services/exam-service.service';

@Component({
  selector: 'app-exam-schedule-questions',
  templateUrl: './exam-schedule-questions.component.html',
  styleUrls: ['./exam-schedule-questions.component.scss']
})
export class ExamScheduleQuestionsComponent implements OnInit {
  selectedSchID: any;
  gridName = 'examScheduleQuestionsGrid';
  constructor(private examSchService: ExamScheduleService, private eventService: EventService) { }

  async ngOnInit() {
    GridUtil.setClearGridSelection();
    if (this.examSchService.selectedSchQuestionId) {
      this.examSchService.selectedSchQuestionId = null;
    }
    this.selectedSchID = (this.examSchService.selectedSchedules?.[0]?.id) ?? 0;
    await this.refreshData();
  }
  data: ITableData = {
    tableRows: [],
    tableParams: {
      filterParams: [
        {
          fieldName: 'examinationScheduleID',
          fieldValue: `${(this.examSchService.selectedSchedules?.[0]?.id) ?? 0}`,
          queryOperand: QueryOperand['=='],
          static: true
        },
        {
          fieldName: 'attempt',
          fieldValue: `${(this.examSchService.selectedSchedules?.[0]?.attempt) ?? 0}`,
          queryOperand: QueryOperand['=='],
          static: true
        }
      ],
      sortParam: {
        fieldName: "",
        orderDirection: 0,
      },
      pageInfo: {
        previousPageSize: 50,
        page: 1,
        pageSize: 50,
        recordCount: 0,
        pageCount: 0
      },
      tableMode: TableMode.serverProcessing,
      selectAll: false
    }
  };

  columns: IColumn[] = [
    {
      displayName: 'Question No',
      fieldName: 'questionNo',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Examination Question ID',
      fieldName: 'examinationQuestionID',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Examination Schedule ID',
      fieldName: 'examinationScheduleID',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Attempt',
      fieldName: 'attempt',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Correct',
      fieldName: 'correct',
      fieldDataType: FieldDataType.boolean,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Answered',
      fieldName: 'answered',
      fieldDataType: FieldDataType.boolean,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'SAQ Answer',
      fieldName: 'sAQAnswer',
      fieldDataType: FieldDataType.enum,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'MarkedStatus',
      fieldName: 'markedStatus',
      fieldDataType: FieldDataType.enum,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Flagged',
      fieldName: 'flagged',
      fieldDataType: FieldDataType.boolean,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Time Answered',
      fieldName: 'timeAnswered',
      fieldDataType: FieldDataType.dateTime,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Viewed',
      fieldName: 'viewed',
      fieldDataType: FieldDataType.boolean,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Time Viewed',
      fieldName: 'timeViewed',
      fieldDataType: FieldDataType.dateTime,
      searchable: true,
      orderable: true,

    },

    {
      displayName: 'Mark Earned',
      fieldName: 'markEarned',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    }
  ];

  onRowClick(idx: any) {
    if (!this.data?.tableRows) { //Just in case tableRows might still not be ready
      setTimeout(() => this.onRowClick(idx), 50);
      return;
    }
    let storedIds = GridUtil.getSelectedDataID(this.gridName) ?? [];
    const examSch: any[] = idx.map(x => this.data.tableRows[x]).filter(Boolean);
    let selectedDataRowsId = storedIds.length > 0 ? storedIds : examSch.map(x => x.id);
    GridUtil.setRowCliclk(this.gridName, idx, selectedDataRowsId);
    this.examSchService.reloadGrid.subscribe((value) => {
      this.refreshData();
    });
    this.examSchService.selectedSchQuestionId = selectedDataRowsId;
  }

  async refreshData() {
    const res: any = await this.examSchService.getExaminationSchedulesQuestions(this.data.tableParams);
    if (!res || res.length === 0) {
      return;
    } this.data.tableRows = [];
    const tableParams = { ...this.data.tableParams, pageInfo: res[0].pageInfo }
    this.data.tableParams = tableParams;
    this.data.tableRows = res.slice(1, res.length);
    setTimeout(() => {
      this.eventService.gridDataLoadedEvent.next(true);
    });
  }
}
